<template>
    <div v-if="order">
        <h1>Order #{{ order.id }}</h1>

        <p v-if="order.description">
            {{ order.description }}
        </p>

        <p>
            <router-link :to="`/store/${storeId}`" class="button">Tillbaka</router-link>
            <button @click.prevent="printWaybill()">Skriv ut följesedel/plocklista</button>
            <button @click.prevent="archive()">Arkivera</button>
        </p>

        <p>
            Subtotal: {{ order.sub_total }} kr
        </p>

        <h2>Köpare</h2>

        <dl>
            <dt>Alias</dt>
            <dd>{{ order.buyer_alias }}</dd>
            <dt>Förnamn</dt>
            <dd>{{ order.buyer_firstname }}</dd>
            <dt>Efternamn</dt>
            <dd>{{ order.buyer_lastname }}</dd>
            <dt>Adress</dt>
            <dd>
                {{ order.buyer_address1 }} {{ order.buyer_address2 }}<br />
                {{ order.buyer_zipcode }} {{ order.buyer_city }}
            </dd>
            <dt>Telefon</dt>
            <dd>{{ order.buyer_phone }}</dd>
            <dt>E-post</dt>
            <dd>{{ order.buyer_email }}</dd>
        </dl>

        <h2>Leverans</h2>

        <dt>Namn</dt>
        <dd>{{ order.ship_name }}</dd>
        <dt>Adress</dt>
        <dd>
            {{ order.ship_address1 }} {{ order.ship_address2 }}<br />
            {{ order.ship_zipcode }} {{ order.ship_city }}
        </dd>
        <dt>Typ</dt>
        <dd>{{ order.shipping_type }}</dd>

        <h2>Artiklar</h2>

        <SalesItemList :sales-items="order.sales_items" :store="store"/>

        <div v-if="order.suborders.length > 0">
            <h2>Kopplade ordrar</h2>

            <ul>
                <li v-for="suborder_id in order.suborders">
                    {{ suborder_id }}
                </li>
            </ul>
        </div>
    </div>
    <p v-else class="app-loader">
        Laddar...
    </p>
</template>

<script>
import traderaOrdersApi from '../repos/tradera-orders'
import SalesItemList from '../components/SalesItemList.vue'

export default {
    name: 'order',
    components: {
        SalesItemList
    },
    data: function () {
        return {
            storeId: null,
            orderId: null,
        }
    },
    computed: {
        store() {
            return this.$store.getters['traderaStores/getById'](this.storeId);
        },
        order() {
            return this.$store.getters['traderaOrders/getById'](this.orderId);
        }
    },
    methods: {
        printWaybill() {
            traderaOrdersApi.printWaybill(this.storeId, this.order.id);
        },
        archive() {
            if (confirm('Är du säker på att du vill arkivera ordern?')) {
                this.$store.dispatch('traderaOrders/archive', this.orderId)
                    .then(() => {
                        this.$router.push(`/store/${this.storeId}`);
                    })
                ;
            }
        }
    },
    created() {
        this.$store.dispatch('traderaStores/getAll');
        this.storeId = parseInt(this.$route.params.store_id, 10);
        this.$store.dispatch('traderaOrders/getAll', {
            storeId: this.storeId,
            filterArchived: false
        });
        this.orderId = parseInt(this.$route.params.id, 10);
    },
    watch: {
        '$route'(to) {
            this.storeId = parseInt(to.params.store_id, 10);
            this.orderId = parseInt(to.params.id, 10);
        }
    }
}
</script>
